import { render } from "./RelatorioLogs.vue?vue&type=template&id=f6ad77ee&scoped=true"
import script from "./RelatorioLogs.vue?vue&type=script&lang=js"
export * from "./RelatorioLogs.vue?vue&type=script&lang=js"

import "./RelatorioLogs.vue?vue&type=style&index=0&id=f6ad77ee&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6ad77ee"]])

export default __exports__